<template>
  <div
    class="pointer-events-auto relative z-20 flex flex-1 bg-ontick-steel-800 py-12"
  >
    <div class="flex w-full flex-col justify-between pb-6 lg:pb-12">
      <div class="flex w-full flex-col">
        <button
          v-for="(tabHref, i) in data"
          :key="i"
          @click="
            $emit('active-tab', tabHref.tag),
              $router.push({ name: 'Conta', query: { tag: tabHref.tag } }),
              toggleIsOpen()
          "
          :class="
            tabActive == tabHref.tag
              ? 'bg-ontick-steel-500 font-normal text-ontick-blue-500'
              : 'font-normal text-gray-300'
          "
          class="relative mx-3 flex rounded-lg px-3 py-3"
        >
          <div class="relative">
            <i
              :class="
                tabActive == tabHref.tag
                  ? 'text-ontick-blue-500'
                  : 'text-gray-300'
              "
              v-html="tabHref.icon"
            ></i>
            <ontick-alert-badge
              class="-top-2 -right-2"
              v-if="hasUnreadMessages && tabHref.tag === 'messages'"
            />
          </div>
          <span class="pl-3" style="white-space: nowrap">{{
            tabHref.name
          }}</span>
        </button>
      </div>

      <social-links-component />
    </div>
    <button
      v-if="isMobile"
      @click="toggleIsOpen"
      class="flex h-full w-5 items-center justify-center bg-ontick-steel-800 text-gray-300 active:bg-ontick-carbon-900"
    >
      <i v-html="$icons.chevron_left"></i>
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SocialLinksComponent from "./social-links.component.vue";
export default {
  components: {
    SocialLinksComponent,
  },

  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
    },
    tabActive: {
      type: String,
    },
  },

  computed: {
    ...mapGetters({ hasUnreadMessages: "config/hasUnreadMessages" }),
  },

  methods: {
    toggleIsOpen() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
